// Co2Calculator API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type Co2CalculatorRequests = {
    shipmentCalculation: RequestConfigFunction<Record<string, any>>,
}

const co2CalculatorRequests: Co2CalculatorRequests = {
    shipmentCalculation: (params) => {
        return {
            url: 'co2-calculator/shipmentcalculation',
            method: 'POST',
            data: params,
        }
    },
}

export default co2CalculatorRequests
